import InfoModal from "../../../../../components/Modal/Info";
import {
  dateTimeFormatter,
  dateTimeFormatterWithDay,
} from "../../../../../global";
import React, { useEffect, useState } from "react";
import axios from "../../../../../config/axios";
import { useTranslation } from "react-i18next";

const BookingHistoryDialog = ({ booking, handleClose }) => {
  const [bookingHistory, setBookingHistory] = useState();
  const { t } = useTranslation();

  useEffect(() => {
    axios
      .get(`/api/v1/stays/${booking.stay_id}/bookings/booking_history.json`)
      .then(function (response) {
        setBookingHistory(response.data.entries);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [booking]);

  return (
    <InfoModal
      handleClose={handleClose}
      title="Buchungsverlauf"
      show={true}
      loading={!bookingHistory}
    >
      {bookingHistory?.map((booking, i) => (
        <div key={booking.id}>
          Buchungsnummer: {booking.id}
          <br />
          {booking.buyer ? (
            <>
              Buchung von: {booking.buyer.full_name}
              <br />
            </>
          ) : (
            <></>
          )}
          Buchungstyp: {booking.booking_type.name}
          <br />
          Status: {t(`booking.statuses.${booking.state}`)}
          <br />
          {booking.booked_from && (
            <>
              Von: {dateTimeFormatter(booking.booked_from)} <br />
            </>
          )}
          {booking.booked_until && (
            <>
              Bis: {dateTimeFormatter(booking.booked_until)}
              <br />
            </>
          )}
          {booking.stay.checkout_confirmed_at && (
            <>
              Checkout: {dateTimeFormatter(booking.stay.checkout_confirmed_at)}
              <br />
            </>
          )}
          {booking.parking_slot_id && (
            <>
              Stellplatz: {booking.parking_slot.name}
              <br />
            </>
          )}
          Herkunft: {t(`booking.sources.${booking.source}`)}
          <br />
          {booking.is_reservation ? (
            "Reservierung " + booking.id
          ) : (
            <></>
          )}
          {booking.paid_at && (
            <>
              Bezahlt am: {dateTimeFormatterWithDay(booking.paid_at)}
              <br />
            </>
          )}
          Bezahlt: {booking.paid_at ? "Ja" : "Nein"}
          <br />
          Zur Buchung:{" "}
          <a target={"_blank"} href={"/dashboard/stays/" + booking.stay_id}>
            Zum Aufenthalt
          </a>
          {bookingHistory.length - 1 !== i && (
            <hr className="sidebar-divider" />
          )}
        </div>
      ))}
    </InfoModal>
  );
};

export default BookingHistoryDialog;
